import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=35206092&scoped=true&"
import script from "./salon.vue?vue&type=script&lang=js&"
export * from "./salon.vue?vue&type=script&lang=js&"
import style0 from "./salon.vue?vue&type=style&index=0&id=35206092&scoped=true&lang=css&"
import style1 from "./salon.vue?vue&type=style&index=1&lang=css&"
import style2 from "./salon.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./salon.vue?vue&type=style&index=3&id=35206092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35206092",
  null
  
)

export default component.exports